import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const renderOptions = options => {
  if(options) {
    return options.map(o => ({
      value: o,
      label: o
    }));
  }
};

const renderPlaceholder = currentCountry => {
  if (!currentCountry.subregions) {
    return "Please select a country";
  }
  return currentCountry.subregions && currentCountry.subregions.length > 0 ? "Subregions..." : "Unavailable";
};

const SubregionsSelect = ({ onSubregionChange, currentCountry = { subregions: [] }, selectedSubregionOptions }) => (
  <Select
    classNamePrefix="Select"
    classNames={{ container: () => "Select__container" }}
    onChange={e => onSubregionChange(e)}
    options={renderOptions(currentCountry.subregions)}
    placeholder={renderPlaceholder(currentCountry)}
    value={selectedSubregionOptions}
    isMulti
    isSearchable={false}
    isDisabled={!(currentCountry.subregions && currentCountry.subregions.length > 0)}
  />
);

SubregionsSelect.propTypes = {
  onSubregionChange: PropTypes.func.isRequired,
  currentCountry: PropTypes.shape({}).isRequired,
  selectedSubregionOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default SubregionsSelect;
